import styled from 'styled-components'

export const Container = styled.section`
  margin-top: 130px;
  @media (max-width: 991px) {
    margin-top: 90px;
  }   
`